<template>
    <section class="our-products">
        <div class="container container--mw-xxl our-products__container">
            <div class="row m-0 our-products__row">
                <div class="col p-0 our-products__column">
                    <TextBlock
                        :heading="'Create'"
                        :button-text="'Build My Brand'"
                        :button-link="'/brand-creator'"
                    >
                        <p class="body-copy body-copy--align-center">
                            Need some help coming up with a new brand name? Use some or all of our KHONSU CREATE tools to assist you on your brand creation journey, saving words you like to your Word Bank along the way.
                        </p>
                    </TextBlock>
                </div>

                <div class="col p-0 our-products__column">
                    <TextBlock
                        :heading="'Check'"
                        :button-text="'Search My Brand'"
                        :button-link="'/brand-checker'"
                    >
                        <p class="body-copy body-copy--align-center">
                            Got a brand name you like?  Use KHONSU CHECK to see if it might be available to secure as a trademark, domain name or social handle.  Or maybe you just want to see how your brand name is being used on the web.  
                        </p>
                    </TextBlock>
                </div>

                <div class="col p-0 our-products__column">
                    <TextBlock
                        :heading="'Test'"
                        :button-text="'Test My Brand'"
                        :button-link="'/products'"
                    >
                        <p class="body-copy body-copy--align-center">
                            <span class="fw-500">COMING SOON...</span><br><br>
                        </p>
                    </TextBlock>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import TextBlock from "@/components/blocks/TextBlock";

    export default {
        name: 'OurProducts',
        components: {
            TextBlock,
        }
    }
</script>